// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PlpViewButtonGridBase: React.FC<{
    size?: number;
}> = ({ size = 16 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
        <path
            fill="currentColor"
            transform="translate(0 -2.86102e-06)"
            d="M2.5 2C2.2249999 2 2 2.2250004 2 2.5L2 5.5C2 5.7749996 2.2249999 6 2.5 6L5.5 6C5.7750001 6 6 5.7749996 6 5.5L6 2.5C6 2.2250004 5.7750001 2 5.5 2L2.5 2ZM1 2.5C1 1.671875 1.671875 1 2.5 1L5.5 1C6.328125 1 7 1.671875 7 2.5L7 5.5C7 6.328125 6.328125 7 5.5 7L2.5 7C1.671875 7 1 6.328125 1 5.5L1 2.5ZM2.5 10C2.2249999 10 2 10.225 2 10.5L2 13.5C2 13.775 2.2249999 14 2.5 14L5.5 14C5.7750001 14 6 13.775 6 13.5L6 10.5C6 10.225 5.7750001 10 5.5 10L2.5 10ZM1 10.5C1 9.671875 1.671875 9 2.5 9L5.5 9C6.328125 9 7 9.671875 7 10.5L7 13.5C7 14.328125 6.328125 15 5.5 15L2.5 15C1.671875 15 1 14.328125 1 13.5L1 10.5ZM13.5 2L10.5 2C10.225 2 10 2.2250004 10 2.5L10 5.5C10 5.7749996 10.225 6 10.5 6L13.5 6C13.775 6 14 5.7749996 14 5.5L14 2.5C14 2.2250004 13.775 2 13.5 2ZM10.5 1L13.5 1C14.328125 1 15 1.671875 15 2.5L15 5.5C15 6.328125 14.328125 7 13.5 7L10.5 7C9.671875 7 9 6.328125 9 5.5L9 2.5C9 1.671875 9.671875 1 10.5 1ZM10.5 10C10.225 10 10 10.225 10 10.5L10 13.5C10 13.775 10.225 14 10.5 14L13.5 14C13.775 14 14 13.775 14 13.5L14 10.5C14 10.225 13.775 10 13.5 10L10.5 10ZM9 10.5C9 9.671875 9.671875 9 10.5 9L13.5 9C14.328125 9 15 9.671875 15 10.5L15 13.5C15 14.328125 14.328125 15 13.5 15L10.5 15C9.671875 15 9 14.328125 9 13.5L9 10.5Z"
        />
    </svg>
);

export default React.memo(PlpViewButtonGridBase);
